import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39cf43da"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39cf43da')) {
      api.createRecord('39cf43da', component.options)
    } else {
      api.reload('39cf43da', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=39cf43da", function () {
      api.rerender('39cf43da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pattern/components/ratio-manage/index.vue"
export default component.exports